import '@leenguyen/react-flip-clock-countdown/dist/index.css';
import { Box, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import React, { memo } from 'react';
import { useTranslations } from 'next-intl';
import { styled } from './styles';
import { useSearchParams } from 'next/navigation';
import LanguagePicker from '../components/header/picker';

interface Props {
  enabled: boolean;
  className?: string;
}

let UpdateFallbackModal: React.FC<Props> = ({ className, enabled }) => {
  const t = useTranslations();
  const hasQuery = useSearchParams();

  const devMode =
    hasQuery?.get?.('devMode') === 'true' ||
    (typeof window !== 'undefined' && window.localStorage.getItem('devMode') === 'true');

  return enabled ? (
    <Dialog
      className={className}
      open={!devMode}
      onClose={() => {
        /* do nothing */
      }}
    >
      <DialogTitle className='dialog_title'>
        <Typography variant='h4'>{t('updateModal.title')}</Typography>
        <LanguagePicker />
      </DialogTitle>
      <DialogContent
        sx={{
          // background: '#1C1929',
          borderTop: 'none',
          paddingTop: '0',
          paddingBottom: '22px !important',
          paddingLeft: '32px !important',
          paddingRight: '32px !important'
        }}
      >
        <Box className='timer_title_wrapper'>
          <Typography variant='h5' className='timer_title'>
            {t('updateModal.subtitle')}
          </Typography>
        </Box>

        <Box className='timer_products_list'>
          <Box className='timer_products_item'>
            <img className='timer_products_img' src='/images/timer/product_1.png' alt='' />
            <img className='timer_products_coin' src='/images/timer/coin_1.png' alt='' />
          </Box>
          <Box className='timer_products_item'>
            <img className='timer_products_img' src='/images/timer/product_2.png' alt='' />
            <img className='timer_products_coin' src='/images/timer/coin_2.png' alt='' />
          </Box>
          <Box className='timer_products_item'>
            <img className='timer_products_img' src='/images/timer/product_3.png' alt='' />
            <img className='timer_products_coin' src='/images/timer/coin_3.png' alt='' />
          </Box>
          <Box className='timer_products_item'>
            <img className='timer_products_img' src='/images/timer/product_4.png' alt='' />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  ) : (
    <></>
  );
};

UpdateFallbackModal = styled(UpdateFallbackModal, {
  '& .MuiDialogTitle-root': {
    // padding: '0 !important'
  },
  '& > .MuiDialog-container > .MuiPaper-root': {
    margin: '16px !important',
    backgroundImage: 'url("/images/timer/timer_background.jpg")',
    backgroundColor: '#1c1929 !important',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    width: '100%',
    maxWidth: 850,

    '@toTablet': {
      maxWidth: '374px !important',
      backgroundImage: 'url("/images/timer/timer_background_mobile.jpg")',
      height: '93vh',

      '& .MuiDialogContent-root': {
        padding: '20px 24px 24px !important',
        display: 'flex',
        flexDirection: 'column',
        // alignItems: 'center',
        // justifyContent: 'center',
        overflowX: 'hidden'
      }
    }
  },
  '& .dialog_title': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    textAlign: 'center',
    position: 'relative',

    '@toTablet': {
      flexDirection: 'column-reverse',
      gap: '20px'
    }
  },
  '& .MuiTypography-root': {
    // paddingTop: '12px !important'
    // paddingBottom: '28px'
  },
  '@keyframes gradientShift': {
    '0%': {
      backgroundPosition: '0% 50%'
    },
    '50%': {
      backgroundPosition: '100% 50%'
    },
    '100%': {
      backgroundPosition: '0% 50%'
    }
  },
  '& .time_title': {
    fontWeight: '700 !important',
    textAlign: 'center',
    letterSpacing: '1.5px',
    padding: '0 32px',

    background: 'linear-gradient(270deg, #1D67B7, #2E4DBF, #5B3D99, #9B3B9B, #1D67B7)',
    backgroundSize: '800% 800%',
    animation: 'gradientShift 6s ease infinite',

    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    color: 'transparent'
  },
  '& .cross_img': {
    position: 'absolute',
    top: '32px',
    right: '32px',
    cursor: 'pointer',
    '@toTablet': {
      top: '16px',
      right: '16px'
    }
  },
  '& .unit_wrapper': {
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    paddingTop: 50,
    marginBottom: 30,

    '@toTablet': {
      paddingTop: 0,
      marginBottom: 28,
      gap: '8px'
    },

    '& .timer_wrapper': {
      padding: '33px 66px',
      borderRadius: 20,
      position: 'relative',

      '@toTablet': {
        padding: '20px 40px'
      }
    },

    '& .timer_ny_head': {
      position: 'absolute',
      zIndex: 2,
      top: -70,
      right: -70,
      width: 155,

      '@toTablet': {
        width: 94,
        transform: 'rotate(-10deg)',
        top: -48,
        right: -36
      }
    },

    '& *': {
      fontFamily: '"Michroma", sans-serif'
    },

    '& .fcc__separator': {
      position: 'relative',

      '@toTablet': {
        marginBottom: 20
      },

      '&::after, &::before': {
        borderRadius: 0,
        width: 5,
        height: 5,

        '@toTablet': {
          width: 4,
          height: 4
        }
      },
      '&::before': {
        marginBottom: 8
      }
    },

    '& .timer_modal': {
      gap: 6
    },

    '& .timer_list': {
      display: 'flex'
    },

    '& .timer_block': {
      display: 'grid',
      justifyContent: 'center',
      alignItems: 'center'
    },

    '& .timer_number, & .timer_separator': {
      textAlign: 'center',
      fontSize: 56,
      color: '#fff',

      '@toTablet': {
        fontSize: 34
      }
    },

    '& .timer_number': {
      display: 'flex'
    },

    '& .timer_separator': {
      lineHeight: 1
    },

    '& .timer_number_num': {
      display: 'block',
      width: 54,
      lineHeight: 1,

      '@toTablet': {
        width: 32
      }
    },

    '& .timer_label': {
      // position: 'relative',
      marginTop: 20,
      fontSize: 25,
      fontWeight: 300,
      textTransform: 'uppercase',
      textAlign: 'center',
      lineHeight: 1,

      '@toTablet': {
        fontSize: 15,
        marginTop: 14
      }
    },

    '& .fcc__unit_time': {
      marginBottom: 50,

      '@toTablet': {
        marginBottom: 30
      }
    }
  },

  '& .timer_title': {
    // fontSize: 36,
    textAlign: 'center',
    color: '#fff',

    // '@toTablet': {
    //   fontSize: 25
    // },

    '&_wrapper': {
      marginBottom: 36,

      '@toTablet': {
        marginBottom: 62
      }
    }
  },

  '& .timer_products_list': {
    display: 'flex',
    gap: 33,
    maxWidth: '100%',
    paddingBottom: 15,

    '@toTablet': {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '27px 22px'
    }
  },

  '& .timer_products_item': {
    position: 'relative',

    '@toTablet': {
      '&:nth-child(1) > .timer_products_coin': {
        top: -34,
        transform: 'none'
      },
      '&:nth-child(2) > .timer_products_coin': {
        top: 'auto',
        right: 'auto',
        bottom: -44,
        left: -46,
        transform: 'none'
      },
      '&:nth-child(3) > .timer_products_coin': {
        top: 'auto',
        bottom: -24,
        transform: 'none'
      }
      // '&:nth-child(3) > .timer_products_coin': {
      //   bottom: -34,
      //   transform: 'none'
      // }
    }
  },

  '& .timer_products_img': {
    maxWidth: 190,
    width: '100%'
  },

  '& .timer_products_coin': {
    width: 98,
    position: 'absolute',
    zIndex: 2,
    top: '50%',
    right: -66,
    transform: 'translateY(-50%)',

    '@toTablet': {
      width: 68,
      right: -46
    }
  },

  '& .textmd': {
    fontSize: '20px'
  },
  '& .soon_item': {
    marginTop: '20px !important',
    color: 'white',
    fontWeight: 'medium !important',
    textAlign: 'center',
    letterSpacing: '1.5px'
  },
  '& .gradiented_title': {
    fontWeight: '600 !important',
    textAlign: 'center',
    letterSpacing: '1.5px',
    padding: '0 32px',
    fontSize: '48px !important',
    textTransform: 'capitalize',

    '@toTablet': {
      fontSize: '32px !important'
    },
    /* Градиент с множеством цветов */
    background: 'linear-gradient(90deg, #1d67b7, #2e4dbf, #5b3d99, #9b3b9b, #1d67b7, #2e4dbf, #5b3d99, #9b3b9b)',

    /* Очень большой размер, чтобы анимация была заметной */
    backgroundSize: '200% 100%',

    /* Анимация движения фона */
    animation: 'gradientText 4s ease-in-out infinite',

    /* Заливка текста градиентом */
    color: 'transparent !important',
    '-webkit-background-clip': 'text',
    'background-clip': 'text'
  }
});

UpdateFallbackModal = memo(UpdateFallbackModal);

export { UpdateFallbackModal };
